import './App.css';
import ReduxProvider from './redux/provider';
import Search from './search/index';
import SearchBar from './search/searchBar';
import { createPortal } from 'react-dom';
import RelatedContent from './search/relatedContent';
import PublicSearch from './search/publicSearch';

const searchResultsWrapper = document.getElementById('search-results-wrap');
const relatedContentWrapper = document.getElementById('related-content');
const publicSearchResultsWrapper = document.getElementById('public-search-results-wrap');

function App() {
  return (
    <ReduxProvider> 
      <>
        <SearchBar />
        {searchResultsWrapper && createPortal(
          <Search />,
          searchResultsWrapper
        )}
        {relatedContentWrapper && createPortal(
          <RelatedContent />,
          relatedContentWrapper
        )}
        {publicSearchResultsWrapper && createPortal(
          <PublicSearch />,
          publicSearchResultsWrapper
        )}
        {/* related items */}
      </>
    </ReduxProvider>
  );
}

export default App;
